<p-confirmDialog
  header="Confirmation"
  key="customer-invoice-dialog"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Yes"
  rejectLabel="No"
></p-confirmDialog>
<p-dialog
  header="Processing Invoice"
  modal="true"
  [(visible)]="showProgressBar"
  appendTo="body"
  [style]="{ top: '45%', left: '45%' }"
>
  <p-progressBar mode="indeterminate"></p-progressBar>
</p-dialog>
<form (ngSubmit)="search()" style="width: 100%">
  <div class="ui-g filterPanel">
    <div class="ui-g-12 ui-md-4 ui-lg-2">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.from.value"
          name="invoiceDateFrom"
          dateFormat="dd/mm/yy"
        >
        </p-calendar>
        <label>From</label>
      </span>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.to.value"
          name="invoiceDateTo"
          dateFormat="dd/mm/yy"
        >
        </p-calendar>
        <label>To</label>
      </span>
    </div>

    <div *ngIf="isVmeMode" class="ui-g-12 ui-md-4 ui-lg-2">
      <p-dropdown
        name="customers"
        [options]="customers"
        [(ngModel)]="filterVal.filters.customerId.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
        filter="true"
      ></p-dropdown>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2">
      <button pButton type="submit" label="Search" class="ui-button btn-to-right"></button>
      <button
        pButton
        type="button"
        label="Clear"
        class="ui-button btn-to-right ui-button-tertiary"
        (click)="clearFilter(dt)"
      ></button>
    </div>
  </div>
</form>

<p-table
  #dt
  [value]="page.items"
  [lazy]="true"
  [rows]="10"
  [responsive]="true"
  [paginator]="true"
  rowHover="true"
  resizableColumns="true"
  [first]="filterVal.first"
  [totalRecords]="page.total"
  (onLazyLoad)="onGridLazyLoad($event)"
  [hidden]="!isLoaded"
  [rowsPerPageOptions]="[5, 10, 20]"
  [pageLinks]="3"
  [(selection)]="selectedInvoice"
  selectionMode="single"
  [sortField]="filterVal.sortField"
  [sortOrder]="filterVal.sortOrder"
>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="customerName" *ngIf="isVmeMode">Customer</th>
      <th pSortableColumn="xeroInvoiceNumber">Invoice</th>
      <th pSortableColumn="invoiceDate">Date</th>
      <th pSortableColumn="billedDate" *ngIf="isTestMode">Billed Date</th>
      <th pSortableColumn="subtotalVAT">Amount(VAT)</th>
      <th pSortableColumn="subtotalNoVAT">Amount(No-VAT)</th>
      <th pSortableColumn="vat">VAT</th>
      <th pSortableColumn="total">Total</th>
      <th>Invoice</th>
      <th>Order Inv.</th>
      <th>Report</th>
      <!-- Temporarily hidden -->
      <!--        <th>Markup Invoice</th>-->
      <th *ngIf="isTestMode">Remove</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item>
    <tr [pSelectableRow]="item" class="no-wrap-cells">
      <td *ngIf="isVmeMode">
        <div>
          <span *ngIf="item.departmentName"
            >{{ item.customerName }} | <b>{{ item.departmentName }}</b></span
          >
          <span *ngIf="!item.departmentName">{{ item.customerName }}</span>
        </div>
      </td>
      <td>{{ item.xeroInvoiceNumber }}</td>
      <td>{{ item.invoiceDate | datex : 'DD MMM YYYY' }}</td>
      <td *ngIf="isTestMode">{{ item.billedDate | datex : 'DD MMM YYYY' }}</td>
      <td>{{ item.subtotalVAT | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
      <td>{{ item.subtotalNoVAT | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
      <td>{{ item.vat | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
      <td>{{ item.total | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
      <td style="text-align: center">
        <span *ngIf="!item.xeroInvoicePdfUrl">Awaiting creation</span>
        <a
          *ngIf="item.xeroInvoicePdfUrl"
          pTooltip="View Invoice"
          tooltipStyleClass="xtooltip"
          tooltipPosition="top"
          (click)="openPdf(item.xeroInvoicePdfUrl); $event.preventDefault()"
        >
          <span class="ui-clickable fa fa-fw ui-icon-document"></span>
        </a>
      </td>

      <td style="text-align: center">
        <div *ngIf="!item.xeroInvoicePdfUrl" pTooltip="Generate standard invoice first">
          <i class="fa fa-stop"></i>
        </div>

        <div
          tooltipStyleClass="xtooltip"
          tooltipPosition="top"
          *ngIf="item.xeroInvoicePdfUrl"
          [pTooltip]="
            !item.orderLevelInvoiceURL
              ? 'Click to generate order-level invoices'
              : 'Download order-level invoice'
          "
        >
          <div *ngIf="item.isBusy" style="color: var(--linkColor)">
            <i class="fa fa-spin fa-spinner"></i>
          </div>

          <div *ngIf="!item.isBusy">
            <span
              *ngIf="!item.orderLevelInvoiceURL"
              style="color: var(--linkColor); cursor: pointer"
              (click)="generateOrderLevelInvoice($event, item)"
            >
              <i class="fa fa-book"></i>
            </span>
            <a *ngIf="item.orderLevelInvoiceURL" (click)="downloadOrderLevelInvoice($event, item)">
              <span class="ui-clickable fa fa-fw ui-icon-file-download"></span>
            </a>
          </div>
        </div>
      </td>

      <td style="text-align: center">
        <a
          (click)="generateCSVReport(item); $event.preventDefault()"
          title="Download Task Level Report"
          *ngIf="item?.enableCustomInvoiceReport"
        >
          <span class="ui-clickable fa fa-fw ui-icon-file-download"></span>
        </a>
      </td>
      <!-- Temporarily hidden -->
      <!--      <td style="text-align: center">-->
      <!--        <a-->
      <!--          *ngIf="item.markupInvoicePdfUrl"-->
      <!--          (click)="openPdf(item.markupInvoicePdfUrl); $event.preventDefault()"-->
      <!--        >-->
      <!--          <span class="ui-clickable fa fa-fw ui-icon-document"></span>-->
      <!--        </a>-->
      <!--      </td>-->
      <td *ngIf="isTestMode" style="text-align: center">
        <a href="#" (click)="removeInvoice(item.id); $event.preventDefault()">Remove</a>
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="footerPanel ui-grid-row">
  <button
    type="button"
    pButton
    icon="fa ui-icon-file-download"
    label="Download"
    class="ui-button btn-to-right"
    (click)="downloadCustomerReport()"
    [disabled]="page.total == 0"
  ></button>
</div>

<div *ngIf="selectedInvoice">
  <div class="ui-grid-row">
    <div class="ui-g-12">
      <h2>Transactions</h2>
      <transaction-lines-grid
        [customerInvoiceId]="selectedInvoice.id"
        [manageMode]="1"
      ></transaction-lines-grid>
    </div>
  </div>
</div>

<div *ngIf="isVmeMode" class="ui-grid-row mt-3">
  <div class="ui-g-12 card">
    <button
      type="button"
      pButton
      label="Process Invoices {{ customerInvoiceProcess.isDryRun == true ? '' : '- Live Run' }}"
      class="ui-button btn-to-right"
      (click)="processInvoices()"
      [ngClass]="{
        '': customerInvoiceProcess.isDryRun,
        'ui-button-danger': !customerInvoiceProcess.isDryRun
      }"
    ></button>
    <div ngClass="invoice-period-container-div pull-right">
      <div class="grid">
        <div class="col-12 md:col-4"><span class="control-label">Invoice Period</span></div>
        <p-dropdown
          ngClass="col-12 md:col-8 invoice-period-dd"
          [options]="invoicePeriodSelect"
          [(ngModel)]="invoicePeriod"
          [style]="{ width: '150px' }"
          placeholder="Select an Invoice Period"
        >
        </p-dropdown>
      </div>
    </div>
    <input
      name="tlinesMax"
      type="hidden"
      pInputText
      [(ngModel)]="tlinesMax"
      style="float: right; margin-right: 20px; padding-top: 5px; width: 50px"
    />
    <div style="float: right; padding-top: 7px; margin-right: 10px; display: none">Lines Max</div>
    <input
      name="runDelayedDays"
      type="hidden"
      pInputText
      [(ngModel)]="runDelayedDays"
      style="float: right; margin-right: 20px; padding-top: 5px; width: 40px"
    />
    <div style="float: right; padding-top: 7px; margin-right: 10px; display: none">
      Delayed days
    </div>
    <p-calendar
      name="plannedRunDay"
      [(ngModel)]="plannedRunDay"
      dateFormat="yy-mm-dd"
      [showIcon]="true"
      [style]="{ float: 'right', 'margin-right': '20px', 'padding-top': '5px' }"
    ></p-calendar>
    <div style="float: right; padding-top: 7px; margin-right: 10px">Planned run day</div>
    <input
      autocomplete="off"
      name="cipPassPhrase"
      pInputText
      placeholder="{{ customerInvoiceProcess.enableWetModeMsg }}"
      class="invoice-process-wet-mode"
      (keyup)="verifyRunMode($event)"
    />
  </div>

  <div *ngIf="billResults">
    <div class="ui-g-12">
      <h1>Billing Result</h1>
      <p-table
        [value]="billResults"
        [rows]="1000"
        [responsive]="true"
        [paginator]="false"
        rowHover="true"
        resizableColumns="true"
        [totalRecords]="billResults.length"
        sortField="transactionsLinked"
        sortOrder="-1"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Customer</th>
            <th>Status</th>
            <th>Status Details</th>
            <th>Total Amount</th>
            <th>Transactions</th>
            <th>Settings: Invoicing Period</th>
            <th>Report</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td>
              <div>
                <span *ngIf="item.departmentName"
                  >{{ item.customerName }} | <b>{{ item.departmentName }}</b></span
                >
                <span *ngIf="!item.departmentName">{{ item.customerName }}</span>
              </div>
            </td>
            <td>{{ item.statusString }}</td>
            <td>{{ item.statusDetails }}</td>
            <td>{{ item.amount | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
            <td>{{ item.transactionsLinked }}</td>
            <td>
              {{
                item.billingSettings.invoicePeriod == 0
                  ? 'monthly'
                  : item.billingSettings.invoicePeriod + ' day(s)'
              }}
            </td>
            <td style="text-align: center">
              <a
                (click)="generateAdhocCSVReport(item); $event.preventDefault()"
                title="Download Task Level Report"
                *ngIf="item?.transactionIds?.length && item?.enableCustomInvoiceReport"
              >
                <span class="ui-clickable fa fa-fw ui-icon-file-download"></span>
              </a>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div *ngIf="xeroResults">
    <div class="ui-g-12">
      <h1>Xero Result</h1>
      <p-table
        [value]="xeroResults"
        [rows]="1000"
        [responsive]="true"
        [paginator]="false"
        rowHover="true"
        resizableColumns="true"
        [totalRecords]="xeroResults.length"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Customer</th>
            <th>Invoice ID</th>
            <th>Invoice Date</th>
            <th>Statuses</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td>{{ item.customerName }}</td>
            <td>{{ item.invoiceId }}</td>
            <td>{{ item.invoiceNumber }}</td>
            <td>{{ item.invoiceDate | datex : 'DD MMM YYYY' }}</td>
            <td>
              <p-table
                [value]="item.statuses"
                [paginator]="false"
                rowHover="true"
                resizableColumns="true"
                [totalRecords]="item.statuses.length"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>status</th>
                    <th>details</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-inner>
                  <tr>
                    <td>{{ inner.statusString }}</td>
                    <td>{{ inner.details }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <!---
            <p-dataTabl [value]="xeroResults" [rows]="1000" [responsive]="true" [paginator]="false" rowHover="true"
                resizableColumns="true" [totalRecords]="xeroResults.length">
                <p-column field="customerName" header="Customer" [style]="{'width' : '10%'}"></p-column>
                <p-column field="invoiceId" header="Invoice ID" [style]="{'width' : '10%'}"></p-column>
                <p-column field="invoiceNumber" header="Invoice Number" [style]="{'width' : '10%'}"></p-column>
                <p-column field="invoiceDate" header="Invoice Date" [style]="{'width' : '10%'}">
                    <ng-template let-col let-item="rowData" pTemplate="body">
                        {{ item[col.field] | datex:'DD MMM YYYY' }}
                    </ng-template>
                </p-column>
                <p-column header="Statuses">
                    <ng-template let-col let-item="rowData" pTemplate="body">
                        <p-dataTabl [value]="item.statuses" [paginator]="false" rowHover="true" resizableColumns="true"
                            [totalRecords]="item.statuses.length">
                            <p-column field="statusString" header="status"></p-column>
                            <p-column field="details" header="details"></p-column>
                        </p-dataTable>
                    </ng-template>
                </p-column>
            </p-dataTable>
            --->
    </div>
  </div>
</div>
